<template>
    <div id="shopsListWrap">
        <section class="list-of-stores-box mt-5">
            <div class="container">
                <SearchHeader></SearchHeader>

                <div class="row category-checkbox-container">
                    <div class="col-lg-3 col-12">
                <SearchSidebar></SearchSidebar>
                    </div>
                    <div class="col-12 col-lg-9 "><!-- content-->
                <SearchContent></SearchContent>
                    </div>
            </div>
            </div>
        </section>
    </div>
</template>

<script>
  import SearchHeader from '@/components/SearchHeader'
  import SearchSidebar from '@/components/SearchSidebar'
  import SearchContent from '@/components/SearchContent'

  export default {
    name: 'App',
    components: {
      SearchHeader,
      SearchSidebar,
      SearchContent
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue